import type { EmptyStateProps, EmptyStatePresetConfig } from '@pushly/aqe/lib/components'

/**
 * The `emptyStates` presets are shaped for a DataView `noData` slot, which names
 * the same parts `text` and `action`. EmptyState names them `title` and `actions`.
 */
export const asEmptyStateProps = (preset: EmptyStatePresetConfig): EmptyStateProps => ({
    icon: preset.icon,
    title: preset.text,
    description: preset.description,
    actions: preset.action,
    footer: preset.footer,
})
